<template>
  <div class="flip-book-add-to-cart-container">
    <FlipBookAddToCartBtnBook
      :product-id="productId"
      :show-quick-view="showQuickView"
      @modal-close="$parent.$emit('modal-close')"
    />
    <FlipBookAddToCartBtnEbook
      :product-id="productId"
      :show-quick-view="showQuickView"
      @modal-close="$parent.$emit('modal-close')"
    />
  </div>
</template>

<script>
import FlipBookAddToCartBtnBook from './FlipBookAddToCartBtnBook.vue'
import FlipBookAddToCartBtnEbook from './FlipBookAddToCartBtnEbook.vue'

export default {
  name: 'FlipBookAddToCartBtn',
  components: {
    FlipBookAddToCartBtnBook,
    FlipBookAddToCartBtnEbook
  },
  props: {
    productId: {
      type: Number,
      default: null
    },
    showImage: {
      type: Boolean,
      default: true
    },
    showName: {
      type: Boolean,
      default: true
    },
    showContent: {
      type: Boolean,
      default: true
    },
    showQuickView: {
      type: Boolean,
      default: false
    },
    showAddToCart: {
      type: Boolean,
      default: true
    },
    isListing: {
      type: Boolean,
      default: false
    },
    isVariationGroupMaster: {
      type: Boolean,
      default: false
    },
    recommendationType: {
      type: String,
      default: null
    },
    recommendationId: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
.flip-book-add-to-cart-container {
  position: relative;
  display: flex;
  justify-items: center;
  align-items: center;
  padding-right: 5rem;
  @media (max-width: 768px) {
    justify-items: flex-start;
    padding: 0;
  }
}
</style>
